var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement, useRef, useContext } from '@max/max';
import View from '@hfe/max-view';
import Text from '@max/leez-text';
import LinearGradient from '@hfe/max-linear-gradient';
import SliderBtn from './slider-btn';
import { useShow } from '@nibfe/marketing-blocks-hook';
import login from '@nibfe/mkt-user-api';
import InflateModal from '../inflate-modal';
import ButtonArrowAnimation from './button-arrow-animation';
import { CouponStatus, claimCoupon, queryInflateCoupon } from '@nibfe/mkt-coupon-api';
import { amountColorConfig, couponBtnConfig, errorMsg, hasValidStateStatusList, lxBidConfig, lxBuIdMap, lxCouponStatusReportMap, buttonStyle } from '../../lib/constant';
import { formatCouponList, getCampaignBizMap, presendRequest, sortCoupon } from '../../utils/coupon';
import { navigateToPage, throttle, yuanToFen, getChannelName } from '../../utils';
import { EResultCode } from '../../lib/interface';
import '../../common.scss';
import './index.scss';
var ButtonType;
(function (ButtonType) {
    ButtonType["PRIMARY"] = "primary";
    ButtonType["PLAIN"] = "plain";
    ButtonType["WEAK"] = "weak";
})(ButtonType || (ButtonType = {}));
export default function CouponButton(props) {
    const { showValue, handleHide, handleShow } = useShow(false);
    const { _uiInteractionAPI, _raptorReport, _moduleId, _runtimeInfo, _LXReport } = useContext(global._EngineGlobalContext);
    let { pageConfig, pageId, rootTag } = _runtimeInfo || {};
    const { cid } = pageConfig || {};
    pageId = String(pageId);
    const { toast } = _uiInteractionAPI || {};
    const { reportLog } = _raptorReport || {};
    const { size = 'small', style = {}, updateCouponList, couponData, currentTimeMillis, beginTime, toastConfig, index, amountColor, location, formatCouponConfigRes, setCurrentTimeMillis, bizLine, hotelchannel } = props;
    const { status, couponGroupId, redirectLink, campaignKey, unifiedCouponId, nibBiz, bizToken, assetType, discountAmount, priceLimit, couponInflateType, maxInflateAmount, isValid } = couponData || {};
    let { btnText = '免费领取', buttonType, isDisable } = couponBtnConfig[status] || {};
    isDisable = hasValidStateStatusList.includes(status) && status !== CouponStatus.CanInflate ? !isValid : isDisable;
    let retryInflateInfoListTimes = useRef(0);
    // 点击按钮
    const clickButton = throttle(() => __awaiter(this, void 0, void 0, function* () {
        _LXReport === null || _LXReport === void 0 ? void 0 : _LXReport.mcReport(lxBidConfig.couponMC, {
            valLab: {
                god_campaign_key: campaignKey,
                god_coupon_id: couponGroupId || -999,
                coupon_status: lxCouponStatusReportMap[status],
                custom: {
                    hotel_channel: hotelchannel,
                    click_biz_line: bizLine
                }
            }
        });
        let toastTip = '';
        switch (status) {
            case CouponStatus.NotStart:
                toastTip = toastConfig.notStartTip;
                break;
            case CouponStatus.SoldOut:
                toastTip = toastConfig.soldOutTip;
                break;
            case CouponStatus.NotClaimed:
                handleClaimCoupon();
                break;
            case CouponStatus.CanInflate:
                handleShow();
                break;
            case CouponStatus.ToUse:
            case CouponStatus.AfterInflate:
                if (!isDisable) {
                    navigateToPage(redirectLink, err => {
                        const parseErr = JSON.parse(err);
                        const errorMsg = JSON.stringify(Object.assign({}, {
                            campaignKey,
                            parseErr
                        }));
                        reportLog(`${status}跳链校验失败`, new Error(errorMsg), {
                            level: 'warn'
                        });
                    }, err => {
                        const parseErr = JSON.parse(err);
                        const errorMsg = JSON.stringify(Object.assign({}, {
                            campaignKey,
                            parseErr
                        }));
                        reportLog(`${status}跳转失败`, new Error(errorMsg), {
                            level: 'warn'
                        });
                    });
                }
                break;
            case CouponStatus.Expired:
            case CouponStatus.Claimed:
            case CouponStatus.Used:
            default:
                break;
        }
        toastTip && (toast === null || toast === void 0 ? void 0 : toast.show({
            content: toastTip
        }));
    }), toastConfig.frequentClickInterval);
    // 膨胀成功回调
    const onInflateSuccess = () => __awaiter(this, void 0, void 0, function* () {
        try {
            const res = yield queryInflateCoupon({
                pageId,
                moduleId: _moduleId,
                unifiedCouponId
            });
            const { resultCode: inflateCouponCode, data: inflateCouponData } = res || {};
            const { inflateInfoList, currentTimeMillis } = inflateCouponData || {};
            if (inflateCouponCode === EResultCode.SUCCESS && (inflateInfoList || []).length) {
                retryInflateInfoListTimes.current = 0;
                let _inflateInfoList = [{
                        campaignKey,
                        couponInfoList: inflateInfoList
                    }];
                _inflateInfoList = formatCouponList(_inflateInfoList, formatCouponConfigRes, [campaignKey], currentTimeMillis);
                _inflateInfoList = sortCoupon(_inflateInfoList);
                setCurrentTimeMillis(currentTimeMillis);
                updateCouponList(_inflateInfoList, {
                    unifiedCouponId
                }, 1);
            }
            else if (inflateCouponCode === EResultCode.UN_LOGIN) {
                yield login.login();
            }
            else {
                retryInflateInfoListTimes.current++;
                // 获取膨后券信息失败，重试2次
                if (retryInflateInfoListTimes.current < 3 && inflateCouponCode !== 0) {
                    onInflateSuccess();
                }
                else {
                    retryInflateInfoListTimes.current = 0;
                    throw new Error(JSON.stringify({
                        unifiedCouponId,
                        res
                    }));
                }
            }
        }
        catch (e) {
            reportLog('获取膨胀后券信息失败', new Error(e.message), {
                level: 'warn'
            });
            toast === null || toast === void 0 ? void 0 : toast.show({
                content: errorMsg
            });
        }
    });
    // 膨胀失败上报
    const inflateFailReport = (label) => {
        reportLog(label, new Error(JSON.stringify({
            campaignKey,
            unifiedCouponId
        })), {
            level: 'warn'
        });
    };
    // 领券
    const handleClaimCoupon = () => __awaiter(this, void 0, void 0, function* () {
        let toastTip = '';
        const claimRes = yield claimCoupon({
            campaignKeys: [campaignKey],
            campaignScene: 1,
            campaignBizMap: getCampaignBizMap([campaignKey], formatCouponConfigRes),
            pageId,
            moduleId: _moduleId,
            mmcParams: location
        }, {}, {
            partner: 806,
            location: {
                latitude: location === null || location === void 0 ? void 0 : location.actualLatitude,
                longitude: location === null || location === void 0 ? void 0 : location.actualLongitude
            }
        });
        const { resultCode: claimCouponCode, resultMessage: claimMessage, data: claimCouponData } = claimRes || {};
        const { detailList } = claimCouponData || {};
        const codeToastMap = new Map([[EResultCode.SUCCESS, toastConfig.successTip], [EResultCode.ISSUE_FAIL, toastConfig.totalFailTip], [EResultCode.NOT_START, toastConfig.notStartTip], [EResultCode.RISK_CONTROL, toastConfig.noPortraitTip], [EResultCode.STOCK_NOT_ENOUGH, toastConfig.soldOutTip], [EResultCode.NO_USER_QUALIFICATION, toastConfig.receivedIneligibility], [EResultCode.ISSUE_NUM_LIMIT, '领取失败，请刷新页面后重试'], [EResultCode.RATE_LIMIT, toastConfig.ratelimit[0]]]);
        if (claimCouponCode === EResultCode.STOCK_NOT_ENOUGH || claimCouponCode === EResultCode.SUCCESS && (detailList || []).length) {
            // 领券成功或库存不足刷新券状态，位置不变
            try {
                toastTip = codeToastMap.get(claimCouponCode);
                const res = yield presendRequest({
                    pageId,
                    moduleId: _moduleId,
                    campaignKeys: [campaignKey],
                    mmcParams: location
                }, formatCouponConfigRes, {
                    rootTag
                });
                if (!res)
                    return;
                const { couponList, currentTimeMillis } = res || {};
                setCurrentTimeMillis(currentTimeMillis);
                updateCouponList(couponList, {
                    campaignKey
                }, 1);
            }
            catch (e) {
                reportLog(`神券预发券报错-领券后-${claimCouponCode}`, e, {
                    level: 'warn'
                });
            }
        }
        else if (claimCouponCode === EResultCode.RISK_CONTROL) {
            // 被风控优先展示后端返回的文案
            toastTip = claimMessage || codeToastMap.get(claimCouponCode) || toastConfig.totalFailTip;
        }
        else if (claimCouponCode === EResultCode.RATE_LIMIT) {
            // 被限流等领取人数过多的情况下随机一个文案展示
            const limitConfigLen = toastConfig.ratelimit.length;
            const randomIndex = Math.floor(Math.random() * limitConfigLen);
            toastTip = toastConfig.ratelimit[randomIndex];
        }
        else if (claimCouponCode === EResultCode.UN_LOGIN) {
            yield login.login();
        }
        else {
            // 其他错误展示对应配置的文案
            toastTip = codeToastMap.get(claimCouponCode) || toastConfig.totalFailTip;
        }
        toastTip && (toast === null || toast === void 0 ? void 0 : toast.show({
            content: toastTip
        }));
        claimCouponCode !== 0 && reportLog('神券领券报错', new Error(JSON.stringify({
            toastTip,
            claimRes
        })), {
            level: 'warn'
        });
    });
    return <View style={{
            overflow: 'visible'
        }} onClick={clickButton}>
      {/* 可膨胀状态下的箭头动画 */}
      <ButtonArrowAnimation x-if={status === CouponStatus.CanInflate} size={size}/>
      <View className="magicmember-coupon-button" style={Object.assign(Object.assign(Object.assign({}, buttonStyle.btnSize[size]), { opacity: buttonType === ButtonType.WEAK || !isDisable ? 1 : 0.5, backgroundColor: '#FFF', borderWidth: buttonType === ButtonType.PLAIN ? '2rpx' : 0, borderColor: '#FF4B10', borderStyle: 'solid' }), style)}>
        <LinearGradient x-if={buttonType === ButtonType.PRIMARY} className="magicmember-coupon-primary-button" start={{
            x: 0,
            y: 0
        }} end={{
            x: 1,
            y: 1
        }} colors={['#FF7A00', '#FF5037', '#FF2F9A', '#FF27C0']}>
          <View x-if={status === CouponStatus.CanInflate}>
            {/* 可膨胀按钮文字滚动动画，slider和箭头动画在滚动过程中会逐渐不匹配，所以手写一个 */}
            <SliderBtn btnText={btnText} maxInflateAmount={maxInflateAmount} size={size}></SliderBtn>
          </View>
          <View style={{
            width: '100%',
            height: '100%'
        }} className="row-center">
            <Text x-else color="#FFF" type={size === 'big' ? 'title4' : 'title5'} lineClamp={1}>
              {btnText}
            </Text>
          </View>
        </LinearGradient>
        <View x-elseif={buttonType === ButtonType.PLAIN} className="magicmember-coupon-plain-button" style={buttonStyle.btnSize[size]}>
          <Text color="#FF4B10" type={size === 'big' ? 'title4' : 'title5'} lineClamp={1}>
            {btnText}
          </Text>
        </View>
        <Text x-else color={isDisable ? '#999' : '#FF4B10'} type={size === 'big' ? 'title4' : 'title5'} lineClamp={1}>
          {btnText}
        </Text>
      </View>
      {/* 膨胀弹窗 */}
      <InflateModal x-if={showValue} inflateData={{
            lxTrackParams: {
                channelName: getChannelName(cid),
                pageInfoKey: '',
                valCid: cid || '',
                valLab: {
                    god_popup_bid: lxBidConfig.componentMV,
                    god_coupon_type: couponInflateType,
                    god_bu_id: lxBuIdMap[nibBiz]
                }
            },
            isHotel: amountColor === amountColorConfig.hotel,
            commonParams: {
                nibBiz,
                pageSource: '24',
                productInfo: {
                    poiId: '',
                    productId: '',
                    bizLine: ''
                },
                position: '2801',
                bizToken,
                location: {
                    latitude: location === null || location === void 0 ? void 0 : location.actualLatitude,
                    longitude: location === null || location === void 0 ? void 0 : location.actualLongitude
                },
                maxInflateAmountCent: yuanToFen(maxInflateAmount)
            },
            magicalMemberCoupon: {
                couponCode: unifiedCouponId,
                applyId: couponGroupId,
                originalRequiredAmount: yuanToFen(priceLimit),
                originalReduceAmount: yuanToFen(discountAmount),
                assetType
            },
            onClosed: handleHide,
            onInflatePreviewSuccess: () => { },
            onInflatePreviewFail: () => {
                inflateFailReport('预膨失败');
            },
            onInflateSuccess,
            onInflateFail: () => {
                inflateFailReport('膨胀失败');
            }
        }}/>
    </View>;
}
